<div id="wrapper" *ngIf="flashPaymentService.controller.operationAmount !== ''">
  <div class="allcont">
    <app-menu
      [tabActive]="tabActive"
      [showUserMobile]="global.showUserMobile"
    ></app-menu>
    <div class="border-type">
      <app-tab-nav
        (updatePostpaid)="postpago = $event"
        (updatePrepaid)="prepago = $event"
        (updateFixed)="telefoniaFijo = $event"
        (updateTotalAccountList)="totalAccountList = $event"
        (updateCurrentList)="currentList = $event"
        (updateSelectBan)="selectBan = $event"
        (updateInitializeData)="initializeData()"
      >
      </app-tab-nav>
    </div>
    <app-add-product *ngIf="totalAccountList == 0"></app-add-product>

    <div
      class="basicrow m-top"
      *ngIf=" totalAccountList > 0"
    >
      <div class="container mobile-with-fix">
        <div class="flash-container">
          <div class="basicr-line-i">
            <div class="fulltitle f-btitle autodef">
              Pago
            </div>
            <div class="pull-right">
              <label class="label-r sidenmbr vcenter w-auto">
                <span class="tabcell"> N&uacute;mero de Cuenta </span>
              </label>
              <div class="autorow subsc mob-wid pull-right">
                <div *ngIf="totalAccountList > 0">
                  <select
                    [(ngModel)]="selectBan"
                    (change)="refreshDataTo($event)"
                    class="sel-f"
                    style="background-image: url(/assets/images/selectabarrw.png)"
                  >
                    <option
                      *ngFor="let list of currentList"
                      [ngValue]="list.account"
                    >
                      {{ list.account }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <app-head-form
            class="max-width"
            [billDueDateField]="billDueDateField"
            [billBalanceField]="billBalanceField"
            [pastDueAmountField]="pastDueAmountField"
            [canUpdateAmount]="canUpdateAmount"
            [editOperationAmount]="editOperationAmount"
            [lastPaymentAmountField]="lastPaymentAmountField"
            [isInvoicePayment]="isInvoicePayment"
            [isPrepaid]="isPrepaid"
            [isInstallment]="isInstallment"
            (action2)="changeAmount($event)"
            (action)="activateChange($event)"
          ></app-head-form>

          <div id="accordion1" class="accordion-container">
            <div class="flash-title-container">
              <div
                class=""
                id="cabecera1"
                data-toggle="collapse"
                data-target="#respuesta1"
                [aria-expanded]="flashPaymentService.controller.step1"
                aria-controls="respuesta1"
              >
                <div
                  class="accordion-section-title"
                  (click)="flashPaymentService.controller.step1 = true;
                  flashPaymentService.controller.step2 = false;
                  flashPaymentService.controller.step3 = false; "
                >
                  <div class="left-title">
                    <div class="id-step step-on">1</div>
                    <div class="title-text">Forma de Pago</div>
                  </div>
                  <div class="rihgt-title">
                    <img
                      src="../../../../assets/images/icon_tarjeta_1.png"
                      alt=""
                      *ngIf="flashPaymentService.controller.isCard"
                      class="img-step1"
                    />

                    <img
                      class="img-fix"
                      src="../../../../assets/images/icon_wallet_2.png"
                      alt=""
                      *ngIf="flashPaymentService.controller.isPlaceToPay"
                      class="img-step1-fix"
                    />

                    <img
                      src="../../../../assets/images/icon_ACH_1.png"
                      alt=""
                      *ngIf="flashPaymentService.controller.isACH"
                      class="img-step1"
                    />
                  </div>
                </div>
              </div>

              <div
                id="respuesta1"
                aria-labelledby="cabecera1"
                data-parent="#accordion1"
                [ngClass]="{
                collapse:
                  !flashPaymentService.controller.step1 ,
                '': flashPaymentService.controller.step1
              }"
              >
                <div class="line-decorator"></div>
                <div class="internal-accordion-container">
                  <app-way-to-pay></app-way-to-pay>
                </div>
              </div>
            </div>
            <div
              class="flash-title-container border-top"
              *ngIf="!flashPaymentService.controller.isPlaceToPay && !flashPaymentService.controller.isACH"
            >
              <div
                id="cabecera2"
                data-toggle="collapse"
                data-target="#respuesta2"
                [aria-expanded]="flashPaymentService.controller.step2"
                aria-controls="respuesta2"
              >
                <div class="accordion-section-title">
                  <div class="left-title">
                    <div
                      class="id-step"
                      [ngClass]="{
                      '': !flashPaymentService.controller.step2,
                      'step-on': flashPaymentService.controller.step2
                    }"
                    >
                      2
                    </div>
                    <div class="title-text">Resumen de Pago</div>
                  </div>
                  <div
                    class="rihgt-title"
                    [ngClass]="{
                    hidden: !flashPaymentService.controller.step2,
                    '': flashPaymentService.controller.step2
                  }"
                  >
                    {{ flashPaymentService.controller.operationAmount | currency }}
                  </div>
                </div>
              </div>
              <div
                id="respuesta2"
                [ngClass]="{
                collapse:
                  !flashPaymentService.controller.step2 || flashPaymentService.controller.step3,
                '': flashPaymentService.controller.step2
              }"
                aria-labelledby="cabecera2"
                data-parent="#accordion1"
              >
                <div class="line-decorator"></div>
                <div
                  class="internal-accordion-container"
                  [ngClass]="{
                  hidden: !flashPaymentService.controller.step2,
                  '': flashPaymentService.controller.step2
                }"
                >
                  <app-payment-summary></app-payment-summary>
                </div>
              </div>
            </div>
            <div class="flash-title-container border-top">
              <div
                id="cabecera3"
                data-toggle="collapse"
                data-target="#respuesta3"
                [aria-expanded]="flashPaymentService.controller.step3"
                aria-controls="respuesta3"
              >
                <div class="accordion-section-title">
                  <div class="left-title">
                    <div
                      class="id-step"
                      [ngClass]="{
                      '': !flashPaymentService.controller.step3,
                      'step-on': flashPaymentService.controller.step3
                    }"
                      *ngIf="!flashPaymentService.controller.isPlaceToPay && !flashPaymentService.controller.isACH"
                    >
                      3
                    </div>

                    <div
                      class="id-step"
                      [ngClass]="{
                      '': !flashPaymentService.controller.step3,
                      'step-on': flashPaymentService.controller.step3
                    }"
                      *ngIf="flashPaymentService.controller.isPlaceToPay || flashPaymentService.controller.isACH"
                    >
                      2
                    </div>

                    <div class="title-text">Confirmacion de Pago</div>
                  </div>
                  <div class="rihgt-title"></div>
                </div>
              </div>
              <div
                id="respuesta3"
                class="collapse"
                [ngClass]="{
                collapse: !flashPaymentService.controller.step3,
                '': flashPaymentService.controller.step3
              }"
                aria-labelledby="cabecera3"
                data-parent="#accordion1"
              >
                <div class="line-decorator"></div>
                <div
                  class="internal-accordion-container"
                  [ngClass]="{
                  hidden: !flashPaymentService.controller.step3,
                  '': flashPaymentService.controller.step3
                }"
                >
                  <app-payment-confirmation></app-payment-confirmation>
                </div>
              </div>
            </div>
          </div>

          <div class="action-container" *ngIf="flashPaymentService.controller.step3">
            <button
              class="btn  btn-exit action-btn"
              (click)="flashPaymentService.goBack()"
            >
              &nbsp; &nbsp; &nbsp; Regresar &nbsp; &nbsp; &nbsp;
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
  <app-footer></app-footer>
</div>



